import React from 'react';
import { classNames } from '../../utils/helpers';

const Button = React.forwardRef(
  ({ 
    children, 
    variant = 'primary', 
    size = 'md', 
    loading = false, 
    disabled = false,
    fullWidth = false,
    className = '',
    ...props 
  }, ref) => {
    const baseClasses = 'font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed transform active:scale-95 relative overflow-hidden group';
    
    const variants = {
      primary: 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white hover:from-cyan-400 hover:to-blue-500 focus:ring-cyan-500 shadow-lg hover:shadow-cyan-500/50 hover:shadow-xl',
      secondary: 'bg-gradient-to-r from-purple-500 to-pink-600 text-white hover:from-purple-400 hover:to-pink-500 focus:ring-purple-500 shadow-lg hover:shadow-purple-500/50 hover:shadow-xl',
      success: 'bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-400 hover:to-emerald-500 focus:ring-green-500 shadow-lg hover:shadow-green-500/50 hover:shadow-xl',
      danger: 'bg-gradient-to-r from-red-500 to-rose-600 text-white hover:from-red-400 hover:to-rose-500 focus:ring-red-500 shadow-lg hover:shadow-red-500/50 hover:shadow-xl',
      outline: 'border-2 border-white/30 bg-white/10 backdrop-blur-md hover:bg-white/20 hover:border-white/50 text-white focus:ring-cyan-500 hover:shadow-lg',
      ghost: 'text-gray-300 hover:text-white hover:bg-white/10 focus:ring-cyan-500 hover:shadow-md backdrop-blur-sm',
    };
    
    const sizes = {
      xs: 'px-3 py-1.5 text-xs rounded-lg',
      sm: 'px-4 py-2 text-sm rounded-xl',
      md: 'px-6 py-2.5 text-sm rounded-xl',
      lg: 'px-8 py-3 text-base rounded-xl',
      xl: 'px-10 py-4 text-lg rounded-2xl',
    };
    
    const classes = classNames(
      baseClasses,
      variants[variant],
      sizes[size],
      fullWidth && 'w-full',
      className
    );

    return (
      <button
        ref={ref}
        className={classes}
        disabled={disabled || loading}
        {...props}
      >
        {/* Shine effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-700"></div>
        
        <span className="relative z-10 flex items-center justify-center gap-2">
          {loading ? (
            <>
              <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Carregando...
            </>
          ) : (
            children
          )}
        </span>
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;